import { setAttribute, isString } from 'maverick.js/std';
import { b as isMediaStream } from '../audio/loader.js';
import { H as HTMLMediaEvents } from './html–media-events.js';
import { N as NativeAudioTracks } from './native-audio-tracks.js';

class HTMLMediaProvider {
  constructor(_media) {
    this.n = _media;
  }
  setup(context) {
    new HTMLMediaEvents(this, context);
    if ("audioTracks" in this.media)
      new NativeAudioTracks(this, context);
  }
  get type() {
    return "";
  }
  get media() {
    return this.n;
  }
  get paused() {
    return this.n.paused;
  }
  get muted() {
    return this.n.muted;
  }
  set muted(muted) {
    this.n.muted = muted;
  }
  get volume() {
    return this.n.volume;
  }
  set volume(volume) {
    this.n.volume = volume;
  }
  get currentTime() {
    return this.n.currentTime;
  }
  set currentTime(time) {
    this.n.currentTime = time;
  }
  get playsinline() {
    return this.n.hasAttribute("playsinline");
  }
  set playsinline(playsinline) {
    setAttribute(this.n, "playsinline", playsinline);
  }
  get playbackRate() {
    return this.n.playbackRate;
  }
  set playbackRate(rate) {
    this.n.playbackRate = rate;
  }
  async play() {
    return this.n.play();
  }
  async pause() {
    return this.n.pause();
  }
  async loadSource({ src }, preload) {
    this.n.preload = preload;
    if (isMediaStream(src)) {
      this.n.srcObject = src;
    } else {
      this.n.srcObject = null;
      this.n.src = isString(src) ? src : window.URL.createObjectURL(src);
    }
    this.n.load();
  }
}

export { HTMLMediaProvider as H };
